import { useState, useEffect } from "react";
import GalleryLightbox from "./GalleryLightbox";

const PORTRAIT_RATIO = 1.0;

function useImageDimensions(images) {
  const [dims, setDims] = useState(null);

  useEffect(() => {
    if (!images || images.length === 0) { setDims([]); return; }
    let resolved = 0;
    const result = new Array(images.length).fill(null);
    images.forEach((src, i) => {
      const img = new window.Image();
      img.onload = () => {
        result[i] = { ratio: img.naturalWidth / img.naturalHeight };
        if (++resolved === images.length) setDims([...result]);
      };
      img.onerror = () => {
        result[i] = { ratio: 1 };
        if (++resolved === images.length) setDims([...result]);
      };
      img.src = src;
    });
  }, [images]);

  return dims;
}

function ProjectGallery({ images }) {
  const dims = useImageDimensions(images);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  if (!images || images.length === 0) return null;

  // Skeleton while dimensions load
  if (!dims) {
    return (
      <div className="flex flex-wrap gap-4">
        {images.map((_, i) => (
          <div
            key={i}
            className="rounded-xl bg-surface-light dark:bg-surface-dark animate-pulse"
            style={{ width: "100%", aspectRatio: "16/9" }}
          />
        ))}
      </div>
    );
  }

  return (
    <>
      <div className="flex flex-wrap gap-4">
        {images.map((src, idx) => {
          // Banner (index 0) and landscape/square images → full width
          // Portrait images → 50% width (pairs up naturally with flex-wrap)
          const isPortrait = idx > 0 && (dims[idx]?.ratio ?? 1) < PORTRAIT_RATIO;

          return (
            <div
              key={idx}
              onClick={() => setLightboxIndex(idx)}
              className="rounded-xl overflow-hidden cursor-zoom-in"
              style={{ width: isPortrait ? "calc(50% - 8px)" : "100%", maxHeight: 1200 }}
            >
              <img
                src={src}
                alt={`View ${idx + 1}`}
                loading="lazy"
                className="block w-full h-auto rounded-xl"
              />
            </div>
          );
        })}
      </div>

      {lightboxIndex !== null && (
        <GalleryLightbox
          images={images}
          initialIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  );
}

export default ProjectGallery;
